<template>
  <div id="container"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

window._AMapSecurityConfig = {
  securityJsCode: 'bec458e6d17ce086b02540efffaeffc6'
}
export default {
  data() {
    return {
      map: null,
      marker: null,
    }
  },
  methods: {
    initMap() {
      AMapLoader.load({
        key: '86c80ea208603ebddfc7d63a267df373', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [''] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then(AMap => {
          this.map = new AMap.Map('container', {
            //设置地图容器id
            viewMode: '2D',
            zoom: 18, //初始化地图级别
            position: [121.236734, 31.391529],
            center: [121.236734, 31.391529],
            title: '鼎固商业中心'
          })
          this.marker = new AMap.Marker({
            position: [121.236734, 31.391529],
            map: this.map
          })
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  mounted() {
    //DOM初始化完成进行地图初始化
    this.initMap()
  }
}
</script>

<style scoped>
#container {
  padding: 0px;
  margin: 0px;
  width: 400px;
  height: 220px;
  border-radius: 20px;
}
</style>
